import { useCallback, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Header } from '@/components/layout/Header';
import { HelpPanel } from '@/components/layout/HelpPanel';
import { Sidebar } from '@/components/layout/Sidebar';
import { masterAdminNav } from '@/config/navigation';
import { BRAND } from '@/config/brand';
import { env } from '@/config/env';
import { useGlobalHelpShortcut } from '@/hooks/useGlobalHelpShortcut';
import { useAppSelector } from '@/hooks/useAppSelector';
import { useWorkspaceTitle } from '@/hooks/useWorkspaceTitle';

export function MasterAdminLayout() {
  const collapsed = useAppSelector((s) => s.app.sidebarCollapsed);
  useWorkspaceTitle();
  const [helpOpen, setHelpOpen] = useState(false);
  const openHelp = useCallback(() => setHelpOpen(true), []);
  useGlobalHelpShortcut(openHelp);

  return (
    <div className="flex h-screen overflow-hidden">
      <Sidebar
        items={masterAdminNav}
        collapsed={collapsed}
        brand={env.appName || BRAND.name}
        appLabel="Master Admin"
      />
      <div className="flex flex-1 flex-col overflow-hidden">
        <Header moduleLabel="Master Admin" onOpenHelp={openHelp} />
        <main className="flex-1 overflow-y-auto p-6">
          <Outlet />
        </main>
      </div>
      <HelpPanel open={helpOpen} onClose={() => setHelpOpen(false)} />
    </div>
  );
}
